module.exports = __webpack_public_path__ + "images/laugh.f6e9051b97cbede6180e.png";